import { Component } from "@angular/core";
import { PageLayout } from "@cvx/nextpage";
import { NumberOfMonths } from "src/app/models/charts/by-request-type/numberOfMonths.enum";
import { WorkflowStates } from "src/app/models/requests/enums/WorkflowStates.enum";


@Component({
    selector: 'dashboard-by-status',
    templateUrl: './dashboard-by-status.component.html'
})

export class DashboardByStatusComponent {
    PageLayout = PageLayout;

    readonly initialRequestStatus = WorkflowStates.Cancelled; // Default to Cancelled status (smaller dataset for initial load)
    numberOfMonths: NumberOfMonths = NumberOfMonths.LastThreeMonths; // Default to last 3 months
}